module.exports = __webpack_public_path__ + "static/media/download-gray.f5f241ee.svg";